"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrandUserBaseEmailTextTemplateType = void 0;
var BrandUserBaseEmailTextTemplateType;
(function (BrandUserBaseEmailTextTemplateType) {
    BrandUserBaseEmailTextTemplateType["NONE"] = "";
    BrandUserBaseEmailTextTemplateType["THANKS_FOR_PLAYING_EMAIL"] = "Thanks for playing Email";
    BrandUserBaseEmailTextTemplateType["LOOSER_EMAIL"] = "Looser Email";
    BrandUserBaseEmailTextTemplateType["NEW_LAUNCH_EMAIL"] = "New launch Email";
    BrandUserBaseEmailTextTemplateType["REMINDER_EMAIL"] = "Reminder Email";
})(BrandUserBaseEmailTextTemplateType || (exports.BrandUserBaseEmailTextTemplateType = BrandUserBaseEmailTextTemplateType = {}));
